
export const PAGE_CONFIG = {
  "title": "分国家明细",
  "titleCN": "分国家明细",
  "subTitle": " ",
  "subTitleCN": " ",
  "path": "/dauByRegion",
  "defaultTab": "activeTrend",
  "tabList": [
    {
      "id": "activeTrend",
      "tabName": "分国家明细",
      "tabNameCN": "分国家明细",
      "isHaveNotification": true,
      "notificationPath": "/dauByRegion/activeTrend",
      "path": "/dauByRegion/activeTrend",
      "logConfig": {
        "pageId": "206701",
        "pageName": "分国家明细",
        "extInfo": "dauByRegion",
        "pagePath": "/dauByRegion"
      },
      "filters": [
        {
          "name": "PcConsoleWeeklyFilter",
          "isOpenSticky": true,
          "isHaveFilterSave": false,
          "filterPath": "/dauByRegion",
          "rangePickerConfig": {
            extraShortcut: [],
            singleWeek: true,
            showShortcut: false,
            disabled: true
          },
          "componentList": [
            {
              "name": "SegmentCo",
              "className": "segment-light margin-t-20",
              "data": {
                "metric_tab": "dau"
              },
              "props": {
                "childrenRenderMode": "byDataKey",
                "childrenMatchField": "id",
                "config": {
                  "dataKey": "metric_tab",
                  "options": [
                    { "value": "dau", "name": "活跃趋势", "nameCn": "活跃趋势" },
                    { "value": "active_retention", "name": "活跃留存", "nameCn": "活跃留存" },
                    { "value": "new_return_retention", "name": "新进回流留存", "nameCn": "新进回流留存" },
                    { "value": "avg_onlinetime_min", "name": "周日平均在线时长", "nameCn": "周日平均在线时长" },
                    { "value": "avg_online_day", "name": "周平均活跃天数", "nameCn": "周平均活跃天数" }
                  ]
                }
              },
              "children": [
                {
                  "id": "dau",
                  "name": "Service",
                  "type": "view",
                  "props": {
                    "api": "/api/v1/dashboard/weekly_analysis/country_metrics_trend",
                    "trackData": ["extraParams", "gameCode"],
                    "dataKey": "keyMetricsData",
                    "beforeRequest": (data: any) => {
                      const { rangeTime, region } = data?.filterVal || {};
                      return Object.assign({
                        game_code: data.gameCode,
                        start_date: rangeTime[0],
                        end_date: rangeTime[1],
                        filters: { market_list: region.markets }
                      }, data.extraParams);
                    },
                    "formatData": (data: any) => {
                      if (!data) return;
                      const dauList = data.list.map((item: any) => {
                        const dateStr = item.date;
                        const formattedDate = `${dateStr.slice(0, 4)}-${dateStr.slice(4, 6)}-${dateStr.slice(6, 8)}`;
                        const lastYearDateStr = item.last_year_version_date;
                        const formattedLastYearDate = lastYearDateStr
                          ? `${lastYearDateStr.slice(0, 4)}-${lastYearDateStr.slice(4, 6)}-${lastYearDateStr.slice(6, 8)}`
                          : '';
                        return {
                          date: formattedDate,
                          today: item.dau,
                          sdlw: item.last_year_version_dau,
                          sdlw_date: formattedLastYearDate
                        };
                      });
                      return { info: data.info?.[0]?.add_info || [], dau: dauList };
                    }
                  },
                  "children": [
                    {
                      "name": "ActiveUsersCardCo",
                      "className": "margin-t-20",
                      "type": "view",
                      "props": {
                        "titleEn": "活跃趋势",
                        "titleCn": "活跃趋势",
                        "subtitle": "{{keyMetricsData.data.info}}",
                        customLegendMap: {
                          Week: { en: ['DAU(当前值)', 'DAU(去年同期)'], cn: ['DAU(当前值)', 'DAU(去年同期)'] },
                        },
                        customTooltipMap: {
                          Week: { en: ['DAU(当前值)', 'DAU(去年同期)'], cn: ['DAU(当前值)', 'DAU(去年同期)'] }
                        },
                        customTableColumns: {
                          Week: [{
                            key: 'sdlw_date',
                            position: 2,
                            render: 'getDateColumnTableOptions',
                            renderParams: {
                              header: { en: '去年同期日期', cn: '去年同期日期' },
                              align: 'right', fixed: 'right', width: 120,
                            },
                          }]
                        },
                        "config": { "type": "dau" },
                        yAxisMin: { enabled: true, minRatio: 0.2 },
                        yAxisFormat: "bmk"
                      },
                      "children": []
                    }
                  ]
                },
                {
                  "id": "active_retention",
                  "name": "Service",
                  "type": "view",
                  "props": {
                    "api": "/api/v1/dashboard/weekly_analysis/country_metrics_trend",
                    "trackData": ["extraParams", "gameCode"],
                    "dataKey": "keyMetricsData",
                    "beforeRequest": (data: any) => {
                      const { rangeTime, region } = data?.filterVal || {};
                      return Object.assign({
                        game_code: data.gameCode,
                        start_date: rangeTime[0],
                        end_date: rangeTime[1],
                        filters: { market_list: region.markets },
                        metrics: ['active_ret_d2', 'active_ret_d30']
                      }, data.extraParams);
                    },
                    "formatData": (data: any) => {
                      if (!data) return;
                      const d2List = data.active_ret_d2_trend_data || [];
                      const d30List = data.active_ret_d30_trend_data || [];
                      const maxLen = Math.max(d2List.length, d30List.length);
                      const list = [];
                      for (let i = 0;i < maxLen;i++) {
                        const d2 = d2List[i] || {};
                        const d30 = d30List[i] || {};
                        const dateStr = d2.date || d30.date || '';
                        list.push({
                          date: dateStr ? `${dateStr.slice(0,4)}-${dateStr.slice(4,6)}-${dateStr.slice(6,8)}` : '',
                          active_ret_d2: d2.value,
                          active_ret_d2_ly: d2.last_year_version_data,
                          active_ret_d30: d30.value,
                          active_ret_d30_ly: d30.last_year_version_data,
                        });
                      }
                      return { info: data.info?.[0]?.add_info || [], retention: list };
                    }
                  },
                  "children": [
                    {
                      "name": "ActiveUsersCardCo",
                      "className": "margin-t-20",
                      "type": "view",
                      "props": {
                        "titleEn": "活跃留存",
                        "titleCn": "活跃留存",
                        "subtitle": "{{keyMetricsData.data.info}}",
                        "config": {
                          "componentMetrics": { "formatRule": "percent1Decimal" },
                          "dataKeyConfig": {
                            "dataKey": "retention",
                            "index": 0,
                            "seriesKeys": ["活跃次留(当前值)", "活跃次留(去年同期)", "活跃30留(当前值)", "活跃30留(去年同期)"],
                            "keyMapping": {
                              "活跃次留(当前值)": "active_ret_d2",
                              "活跃次留(去年同期)": "active_ret_d2_ly",
                              "活跃30留(当前值)": "active_ret_d30",
                              "活跃30留(去年同期)": "active_ret_d30_ly"
                            }
                          },
                        },
                        yAxisMin: { enabled: false, min: 0 },
                        yAxisFormat: "percentInt"
                      },
                      "children": []
                    }
                  ]
                },
                {
                  "id": "new_return_retention",
                  "name": "Service",
                  "type": "view",
                  "props": {
                    "api": "/api/v1/dashboard/weekly_analysis/country_metrics_trend",
                    "trackData": ["extraParams", "gameCode"],
                    "dataKey": "keyMetricsData",
                    "beforeRequest": (data: any) => {
                      const { rangeTime, region } = data?.filterVal || {};
                      return Object.assign({
                        game_code: data.gameCode,
                        start_date: rangeTime[0],
                        end_date: rangeTime[1],
                        filters: { market_list: region.markets },
                        metrics: ['new_ret_d2', 'return_ret_d2']
                      }, data.extraParams);
                    },
                    "formatData": (data: any) => {
                      if (!data) return;
                      const newList = data.new_ret_d2_trend_data || [];
                      const returnList = data.return_ret_d2_trend_data || [];
                      const maxLen = Math.max(newList.length, returnList.length);
                      const list = [];
                      for (let i = 0;i < maxLen;i++) {
                        const n = newList[i] || {};
                        const r = returnList[i] || {};
                        const dateStr = n.date || r.date || '';
                        list.push({
                          date: dateStr ? `${dateStr.slice(0,4)}-${dateStr.slice(4,6)}-${dateStr.slice(6,8)}` : '',
                          new_ret_d2: n.value,
                          new_ret_d2_ly: n.last_year_version_data,
                          return_ret_d2: r.value,
                          return_ret_d2_ly: r.last_year_version_data,
                        });
                      }
                      return { info: data.info?.[0]?.add_info || [], retention: list };
                    }
                  },
                  "children": [
                    {
                      "name": "ActiveUsersCardCo",
                      "className": "margin-t-20",
                      "type": "view",
                      "props": {
                        "titleEn": "新进回流留存",
                        "titleCn": "新进回流留存",
                        "subtitle": "{{keyMetricsData.data.info}}",
                        "config": {
                          "componentMetrics": { "formatRule": "percent1Decimal" },
                          "dataKeyConfig": {
                            "dataKey": "retention",
                            "index": 0,
                            "seriesKeys": ["新进次留(当前值)", "新进次留(去年同期)", "回流次留(当前值)", "回流次留(去年同期)"],
                            "keyMapping": {
                              "新进次留(当前值)": "new_ret_d2",
                              "新进次留(去年同期)": "new_ret_d2_ly",
                              "回流次留(当前值)": "return_ret_d2",
                              "回流次留(去年同期)": "return_ret_d2_ly"
                            }
                          },
                        },
                        yAxisMin: { enabled: false, min: 0 },
                        yAxisFormat: "percentInt"
                      },
                      "children": []
                    }
                  ]
                },
                {
                  "id": "avg_onlinetime_min",
                  "name": "Service",
                  "type": "view",
                  "props": {
                    "api": "/api/v1/dashboard/weekly_analysis/country_metrics_trend",
                    "trackData": ["extraParams", "gameCode"],
                    "dataKey": "keyMetricsData",
                    "beforeRequest": (data: any) => {
                      const { rangeTime, region } = data?.filterVal || {};
                      return Object.assign({
                        game_code: data.gameCode,
                        start_date: rangeTime[0],
                        end_date: rangeTime[1],
                        filters: { market_list: region.markets },
                        metrics: ['avg_onlinetime_min']
                      }, data.extraParams);
                    },
                    "formatData": (data: any) => {
                      if (!data) return;
                      const trendList = data.avg_onlinetime_min_trend_data || [];
                      const dauList = trendList.map((item: any) => {
                        const dateStr = item.date || '';
                        return {
                          date: dateStr ? `${dateStr.slice(0,4)}-${dateStr.slice(4,6)}-${dateStr.slice(6,8)}` : '',
                          today: item.value,
                          sdlw: item.last_year_version_data,
                        };
                      });
                      return { info: data.info?.[0]?.add_info || [], dau: dauList };
                    }
                  },
                  "children": [
                    {
                      "name": "ActiveUsersCardCo",
                      "className": "margin-t-20",
                      "type": "view",
                      "props": {
                        "titleEn": "周日平均在线时长",
                        "titleCn": "周日平均在线时长",
                        "subtitle": "{{keyMetricsData.data.info}}",
                        customLegendMap: {
                          Week: { en: ['周日平均在线时长(当前值)', '周日平均在线时长(去年同期)'], cn: ['周日平均在线时长(当前值)', '周日平均在线时长(去年同期)'] },
                        },
                        customTooltipMap: {
                          Week: { en: ['周日平均在线时长(当前值)', '周日平均在线时长(去年同期)'], cn: ['周日平均在线时长(当前值)', '周日平均在线时长(去年同期)'] }
                        },
                        "config": { "type": "dau" },
                        yAxisMin: { enabled: true, minRatio: 0.2 },
                      },
                      "children": []
                    }
                  ]
                },
                {
                  "id": "avg_online_day",
                  "name": "Service",
                  "type": "view",
                  "props": {
                    "api": "/api/v1/dashboard/weekly_analysis/country_metrics_trend",
                    "trackData": ["extraParams", "gameCode"],
                    "dataKey": "keyMetricsData",
                    "beforeRequest": (data: any) => {
                      const { rangeTime, region } = data?.filterVal || {};
                      return Object.assign({
                        game_code: data.gameCode,
                        start_date: rangeTime[0],
                        end_date: rangeTime[1],
                        filters: { market_list: region.markets },
                        metrics: ['avg_online_day']
                      }, data.extraParams);
                    },
                    "formatData": (data: any) => {
                      if (!data) return;
                      const trendList = data.avg_online_day_trend_data || [];
                      const dauList = trendList.map((item: any) => {
                        const dateStr = item.date || '';
                        return {
                          date: dateStr ? `${dateStr.slice(0,4)}-${dateStr.slice(4,6)}-${dateStr.slice(6,8)}` : '',
                          today: item.value,
                          sdlw: item.last_year_version_data,
                        };
                      });
                      return { info: data.info?.[0]?.add_info || [], dau: dauList };
                    }
                  },
                  "children": [
                    {
                      "name": "ActiveUsersCardCo",
                      "className": "margin-t-20",
                      "type": "view",
                      "props": {
                        "titleEn": "周平均活跃天数",
                        "titleCn": "周平均活跃天数",
                        "subtitle": "{{keyMetricsData.data.info}}",
                        customLegendMap: {
                          Week: { en: ['周平均活跃天数(当前值)', '周平均活跃天数(去年同期)'], cn: ['周平均活跃天数(当前值)', '周平均活跃天数(去年同期)'] },
                        },
                        customTooltipMap: {
                          Week: { en: ['周平均活跃天数(当前值)', '周平均活跃天数(去年同期)'], cn: ['周平均活跃天数(当前值)', '周平均活跃天数(去年同期)'] }
                        },
                        "config": {
                          "type": "dau",
                          "componentMetrics": { "formatRule": "thousands1Decimal" }
                        },
                        yAxisMin: { enabled: false, min: 0 },
                        yAxisFormat: "thousandsInit"
                      },
                      "children": []
                    }
                  ]
                },

              ]
            },
          ]
        }
      ]
    },
  ]
};
